module.exports = __webpack_public_path__ + "files/f775f9cca88e21d45bebe185b27c0e5b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.5.0
 ** module id = 838
 ** module chunks = 0
 **/